<template>
  <div class="type">
    <el-dialog :close-on-click-modal="false"
      title="添加类别123"
      :visible.sync="addProDialogVisible"
      :before-close="addProHandleClose"
      width="490px"
      center
    >
      <div class="content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleFormclass" label-width="100px" class="demo-ruleForm">
          <el-form-item label="名称：" prop="name">
            <el-input v-model="ruleForm.name" maxlength="15"></el-input>
          </el-form-item>
          <!-- <el-form-item label="排序：">
            <el-input v-model="ruleForm.sort"></el-input>
          </el-form-item> -->
          <el-form-item label="状态：" prop="state">
            <el-select v-model="ruleForm.state" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="contentBtns">
            <!-- <div>重置</div> -->
            <div @click="addBtns('ruleFormclass')">确认保存</div>
        </div>
      </div>
     </el-dialog>
  </div>
</template>
<script>
import {ClassAdd,ClassUpdate} from '@/request/scenic.js'
import {Message, Row} from "element-ui"
    export default{
      data(){
        return{
          addProDialogVisible:false,
          ruleForm:{
            token:window.sessionStorage.getItem('Token'),
            name:'',
            state:'',
            sort:''
          },
          rules:{
            name: [
              { required: true, message: '请输入名称', trigger: 'blur' }
            ],
            state:[{ required: true, message: '请选择分类状态', trigger: 'change'}]
          },
          options:[
            {
              value:'0',
              label:'下架'
            },
            {
              value:'1',
              label:'上架'
            }
          ],
          title:''
        }
      },
      methods:{
        pxFn(row){
          if(row.id){
            this.title = '修改分类'
            this.ruleForm={
              token:window.sessionStorage.getItem('Token'),
              name:row.name,
              state:row.state + '',
              sort:row.sort,
              id:row.id
            }
          }else{
            this.title = '添加分类'
            this.ruleForm={
              token:window.sessionStorage.getItem('Token'),
              name:'',
              state:'',
              // sort:''
            }
          }
          this.addProDialogVisible = true
        },
        addProHandleClose(){
          this.addProDialogVisible = false
          this.$emit('close')
        },
        addBtns(classBtns){
          this.$refs[classBtns].validate((valid) => {
          if (valid) {
            if(this.ruleForm.id){
              ClassUpdate(this.ruleForm).then(res=>{
                if(res.data.status=='ok'){
                  this.addProDialogVisible = false
                  this.$emit('close')
                  Message.success('修改分类成功')
                }else{
                  Message.error(res.data.msg)
                }
              })
            }else{
              ClassAdd(this.ruleForm).then(res=>{
              if(res.data.rcode=='200'){
                this.addProDialogVisible = false
                this.$emit('close')
                Message.success('添加分类成功')
              }else{
                Message.error(res.data.msg)
              }
            })
            }
          } else {
            return false
          }
        })
        },
      }
    }
</script>

<style scoped lang="less">
::v-deep .el-dialog__body{
  padding: 2rem 0 !important;
  border-top: 1px solid #E5E5EA;
}
.content{
  padding: 0 2rem 2rem 2rem;
  box-sizing: border-box;
  ::v-deep .el-select{
    width: 100%;
  }
  .contentBtns{
    margin-top: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    div{
      width: 10rem;
      height: 4rem;
      border-radius: 4px;
      line-height: 4rem;
      text-align: center;
      color: #fff;
      font-size: 1.4rem;
      cursor: pointer;
 
        background: #246DEB;
    }
  }
}
.type ::v-deep .el-dialog__wrapper{
  display: flex;
  align-items: center;
  margin-top: 0;
}
</style>